import React, { useState, useEffect, useCallback } from 'react';
import CellRenderer from './CellRenderer';

const TOKEN = document.querySelector("[name='csrf-token']")?.content;

export default function SubformCell({ value, column, formato, format_category }) {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [fetched, setFetched] = useState(false);

  if (!value || !value.startsWith('subform:')) return <span />;

  const parts = value.split(':');
  const parentSurveyId = parts[1];
  const childFormatId = parts[2];
  const surveyToken = parts[3];

  const gestionUrl = `/formatos/format_categories/${format_category?.token}/formats/${formato?.token}/gestion/${surveyToken}?format_association_id=${column.format_relation_id}`;

  const fetchSubformData = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: '1',
        per_page: '100',
        sort_field: 'default',
        sort_dir: 'asc',
        survey_parent_id: parentSurveyId
      });
      const res = await fetch(
        `/formatos/records/${childFormatId}/data?${params.toString()}`,
        { headers: { 'X-CSRF-Token': TOKEN, 'Content-Type': 'application/json' } }
      );
      const json = await res.json();
      setColumns(json.columns || []);
      setRows(json.rows || []);
    } catch (err) {
      console.error('SubformCell fetch error:', err);
    } finally {
      setLoading(false);
      setFetched(true);
    }
  }, [childFormatId, parentSurveyId]);

  const handleOpen = (e) => {
    e.stopPropagation();
    setShowModal(true);
    if (!fetched) fetchSubformData();
  };

  useEffect(() => {
    if (!showModal) return;
    const handleKey = (e) => { if (e.key === 'Escape') setShowModal(false); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [showModal]);

  return (
    <>
      <span className="cm-cell-subform-link" onClick={handleOpen}>
        <i className="fas fa-list" /> Ver registros
      </span>
      {showModal && (
        <div className="cm-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="cm-modal-matrix" style={{ maxWidth: 900 }} onClick={e => e.stopPropagation()}>
            <div className="cm-modal-matrix__header">
              <span className="cm-modal-matrix__title">{column.name}</span>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <a
                  href={gestionUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cm-btn cm-btn--sm cm-btn--primary"
                >
                  <i className="fas fa-external-link-alt" /> Ir al registro
                </a>
                <button className="cm-modal-richtext__close" onClick={() => setShowModal(false)}>
                  <i className="fas fa-times" />
                </button>
              </div>
            </div>
            <div className="cm-modal-matrix__body">
              {loading ? (
                <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>
                  <i className="fas fa-spinner fa-spin" style={{ fontSize: 24 }} />
                  <p style={{ marginTop: 8 }}>Cargando registros...</p>
                </div>
              ) : rows.length === 0 ? (
                <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>
                  <i className="fas fa-folder-open" style={{ fontSize: 24 }} />
                  <p style={{ marginTop: 8 }}>Sin registros</p>
                </div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table className="cm-dt__table">
                    <thead>
                      <tr>
                        <th className="cm-dt__th" style={{ width: 40 }}>#</th>
                        {columns.map(col => (
                          <th key={col.id} className="cm-dt__th">{col.name}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, i) => (
                        <tr key={row.id} className="cm-dt__row">
                          <td className="cm-dt__td" style={{ width: 40, color: '#999' }}>{i + 1}</td>
                          {columns.map(col => {
                            const cell = row.cells[col.id.toString()] || {};
                            return (
                              <td key={col.id} className="cm-dt__td" style={cell.s || undefined}>
                                <CellRenderer
                                  cell={cell}
                                  column={{ ...col, editable: false }}
                                  isEditing={false}
                                  onStartEdit={() => {}}
                                  onCancel={() => {}}
                                  onSave={() => {}}
                                  formato={formato}
                                  format_category={format_category}
                                />
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
